<template>
    <div class="swiper-container">

        <div class="swiper-wrapper timeline">

            <div class="swiper-slide" v-for="item in steps" :class="{'photo' : item.thumb}">
                <div class="content-holder">
                    <div class="date">{{ item.date }}</div>
                    <div class="title">{{ item.title }}</div>
                    <div class="description">{{ item.description }}</div>
                </div>
                <div class="bubble" @click="showImage(item.full)" :style="{backgroundImage: `url(${item.thumb})`}"></div>
                <div class="content-holder"></div>
            </div>

        </div>

        <sweet-modal
                ref="modal"
                @close="image = null"
        >
            <img :src="image" class="img-fluid" />
        </sweet-modal>
    </div>
</template>

<script>
    import Swiper from 'swiper';
    import { SweetModal } from 'sweet-modal-vue';

    export default {
        name: "Timeline",
        components: {
            SweetModal,
        },
        props: {
            steps: Array
        },
        data() {
            return {
                image: null
            }
        },
        mounted() {
            const swiper = new Swiper('.swiper-container', {
                //pagination: '.swiper-pagination',
                slidesPerView: 'auto',
                paginationClickable: true,
                grabCursor: true,
                watchOverflow: true
            });

            this.steps.forEach(step => {
                if (step.full) {
                    let image = new Image();
                    image.src = step.full;
                }
            })
        },
        methods: {
            showImage(url) {
                this.image = url;
                this.$refs.modal.open()
            }
        }
    }
</script>

<style scoped>

</style>